// extracted by mini-css-extract-plugin
module.exports = {"row":"NewCollection_row__2QOcg","col":"NewCollection_col__3PVq7","card":"NewCollection_card__l6RKY"};